import { Injectable } from '@angular/core';

import { map, Observable } from 'rxjs';

import { LocationRouteCffService } from '@fcom/core';
import { LanguageService } from '@fcom/ui-translate';
import { finShare } from '@fcom/rx';

@Injectable()
export class TimetableLocationsService {
  constructor(
    private languageService: LanguageService,
    private locationRouteCffService: LocationRouteCffService
  ) {}
  locationCodeToNameCache: Record<string, Observable<string>> = {};

  getCityNameForLocationCode = (locationCode: string): Observable<string> => {
    if (this.locationCodeToNameCache[locationCode]) {
      return this.locationCodeToNameCache[locationCode];
    }

    this.locationCodeToNameCache[locationCode] = this.locationRouteCffService
      .bestGuessFor(locationCode, this.languageService.localeValue)
      .pipe(
        map((location) => location.cityName),
        finShare()
      );

    return this.locationCodeToNameCache[locationCode];
  };
}
